"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.state = initialState || this.getEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    getEmptyBoard() {
        return Array(4).fill(null).map(()=>Array(4).fill(0));
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.state.map((row)=>[
                ...row
            ]);
    }
    getStatus() {
        return this.status;
    }
    start() {
        if (this.status === "idle") {
            this.status = "playing";
            this.addRandomTile();
            this.addRandomTile();
        }
    }
    restart() {
        this.state = this.getEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    addRandomTile() {
        const emptyCells = [];
        this.state.forEach((row, y)=>{
            row.forEach((cell, x)=>{
                if (cell === 0) emptyCells.push({
                    y: y,
                    x: x
                });
            });
        });
        if (emptyCells.length > 0) {
            const { y: y, x: x } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            this.state[y][x] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    moveLeft() {
        if (this.status !== "playing") return false;
        let moved = false;
        const newState = this.state.map((row)=>{
            let nonZero = row.filter((cell)=>cell !== 0);
            for(let i = 0; i < nonZero.length - 1; i++)if (nonZero[i] === nonZero[i + 1]) {
                nonZero[i] *= 2;
                this.score += nonZero[i];
                nonZero[i + 1] = 0;
            }
            nonZero = nonZero.filter((cell)=>cell !== 0);
            while(nonZero.length < 4)nonZero.push(0);
            return nonZero;
        });
        const hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
        if (hasChanged) {
            this.state = newState;
            this.addRandomTile();
            moved = true;
        }
        this.checkGameStatus();
        return moved;
    }
    moveRight() {
        if (this.status !== "playing") return false;
        let moved = false;
        const newState = this.state.map((row)=>{
            let nonZero = row.filter((cell)=>cell !== 0).reverse();
            for(let i = 0; i < nonZero.length - 1; i++)if (nonZero[i] === nonZero[i + 1]) {
                nonZero[i] *= 2;
                this.score += nonZero[i];
                nonZero[i + 1] = 0;
            }
            nonZero = nonZero.filter((cell)=>cell !== 0);
            while(nonZero.length < 4)nonZero.push(0);
            return nonZero.reverse();
        });
        const hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
        if (hasChanged) {
            this.state = newState;
            this.addRandomTile();
            moved = true;
        }
        this.checkGameStatus();
        return moved;
    }
    moveUp() {
        if (this.status !== "playing") return false;
        let moved = false;
        const newState = this.getEmptyBoard();
        for(let col = 0; col < 4; col++){
            let column = [];
            for(let row = 0; row < 4; row++)if (this.state[row][col] !== 0) column.push(this.state[row][col]);
            for(let i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                column[i] *= 2;
                this.score += column[i];
                column[i + 1] = 0;
            }
            column = column.filter((cell)=>cell !== 0);
            while(column.length < 4)column.push(0);
            for(let row = 0; row < 4; row++)newState[row][col] = column[row];
        }
        const hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
        if (hasChanged) {
            this.state = newState;
            this.addRandomTile();
            moved = true;
        }
        this.checkGameStatus();
        return moved;
    }
    moveDown() {
        if (this.status !== "playing") return false;
        let moved = false;
        const newState = this.getEmptyBoard();
        for(let col = 0; col < 4; col++){
            let column = [];
            for(let row = 3; row >= 0; row--)if (this.state[row][col] !== 0) column.push(this.state[row][col]);
            for(let i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                column[i] *= 2;
                this.score += column[i];
                column[i + 1] = 0;
            }
            column = column.filter((cell)=>cell !== 0);
            while(column.length < 4)column.push(0);
            for(let row = 0; row < 4; row++)newState[3 - row][col] = column[row];
        }
        const hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
        if (hasChanged) {
            this.state = newState;
            this.addRandomTile();
            moved = true;
        }
        this.checkGameStatus();
        return moved;
    }
    checkGameStatus() {
        if (this.state.some((row)=>row.includes(2048))) {
            this.status = "win";
            return;
        }
        if (!this.hasAvailableMoves()) this.status = "lose";
    }
    hasAvailableMoves() {
        if (this.state.some((row)=>row.includes(0))) return true;
        for(let y = 0; y < 4; y++)for(let x = 0; x < 3; x++){
            if (this.state[y][x] === this.state[y][x + 1]) return true;
        }
        for(let x = 0; x < 4; x++)for(let y = 0; y < 3; y++){
            if (this.state[y][x] === this.state[y + 1][x]) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button--start");
const $09e991522ca7e64e$var$helpButton = document.querySelector(".button--help");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-header__score-value");
const $09e991522ca7e64e$var$fieldCells = document.querySelectorAll(".game-field__cell");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message--start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message--win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message--lose");
const $09e991522ca7e64e$var$modal = document.querySelector(".modal");
const $09e991522ca7e64e$var$modalContent = document.querySelector(".modal__content");
const $09e991522ca7e64e$var$closeModalBtn = document.querySelector(".modal__close");
const $09e991522ca7e64e$var$modalCloseBtn = document.querySelector(".modal__button");
let $09e991522ca7e64e$var$previousState = $09e991522ca7e64e$var$game.getState();
function $09e991522ca7e64e$var$updateUI() {
    const newState = $09e991522ca7e64e$var$game.getState();
    newState.forEach((row, y)=>{
        row.forEach((value, x)=>{
            const cell = $09e991522ca7e64e$var$fieldCells[y * 4 + x];
            const prevValue = $09e991522ca7e64e$var$previousState[y][x];
            cell.textContent = value || "";
            cell.className = "game-field__cell";
            if (value) cell.classList.add(`game-field__cell--${value}`);
            if (value !== prevValue) {
                cell.classList.add("game-field__cell--appear");
                setTimeout(()=>{
                    cell.classList.remove("game-field__cell--appear");
                }, 150);
            }
        });
    });
    $09e991522ca7e64e$var$previousState = newState.map((row)=>[
            ...row
        ]);
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$messageStart.classList.toggle("hidden", $09e991522ca7e64e$var$game.getStatus() !== "idle");
    $09e991522ca7e64e$var$messageWin.classList.toggle("hidden", $09e991522ca7e64e$var$game.getStatus() !== "win");
    $09e991522ca7e64e$var$messageLose.classList.toggle("hidden", $09e991522ca7e64e$var$game.getStatus() !== "lose");
    $09e991522ca7e64e$var$startButton.textContent = $09e991522ca7e64e$var$game.getStatus() === "idle" ? "Start" : "Restart";
    $09e991522ca7e64e$var$startButton.classList.toggle("button--start", $09e991522ca7e64e$var$game.getStatus() === "idle");
    $09e991522ca7e64e$var$startButton.classList.toggle("button--restart", $09e991522ca7e64e$var$game.getStatus() !== "idle");
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$updateUI();
});
function $09e991522ca7e64e$var$openModal() {
    $09e991522ca7e64e$var$modal.classList.remove("modal--hidden");
    document.body.style.overflow = "hidden";
    if ($09e991522ca7e64e$var$modalContent) $09e991522ca7e64e$var$modalContent.scrollTop = 0;
}
function $09e991522ca7e64e$var$closeModal() {
    $09e991522ca7e64e$var$modal.classList.add("modal--hidden");
    document.body.style.overflow = "";
}
$09e991522ca7e64e$var$helpButton.addEventListener("click", $09e991522ca7e64e$var$openModal);
$09e991522ca7e64e$var$closeModalBtn.addEventListener("click", $09e991522ca7e64e$var$closeModal);
$09e991522ca7e64e$var$modalCloseBtn.addEventListener("click", $09e991522ca7e64e$var$closeModal);
window.addEventListener("click", (e)=>{
    if (e.target === $09e991522ca7e64e$var$modal) $09e991522ca7e64e$var$closeModal();
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "Escape" && !$09e991522ca7e64e$var$modal.classList.contains("modal--hidden")) {
        $09e991522ca7e64e$var$closeModal();
        return;
    }
    if (!$09e991522ca7e64e$var$modal.classList.contains("modal--hidden") || $09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$updateUI();
});
$09e991522ca7e64e$var$updateUI();


//# sourceMappingURL=index.ebeb5e2a.js.map
